let lenisInstance = null;

export function setLenis(l) {
  lenisInstance = l;
}

export function scrollToTop() {
  if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}
